import {
  addCorpConfigApi,
  queryCorpConfigApi,
  updateCorpConfigApi,
  synchCorpUserApi,
  getCorpUserListApi,
  addCorpUserRoleApi,
  getCorpUserRoleListApi,
  updateCorpUserRoleApi,
  deleteCorpUserRoleApi,
  setCorpUserRoleApi,
  activateCorpUserApi,
  getChatRecordListApi,
  getChatRecordDetailListApi,
  updateCorpUserApi,
  getWxAppLiveRoomListApi,
  addWechatRelationNoticeBindApi,
  deleteWechatRelationNoticeBindApi,
  queryWechatRelationNoticeBindApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加企业微信配置
  async addCorpConfigAction(context, param) {
    const res = await addCorpConfigApi(param)
    return res
  },
  //  查询企业微信配置
  async queryCorpConfigAction(context, param) {
    const res = await queryCorpConfigApi(param)
    return res
  },
  //  修改企业微信配置
  async updateCorpConfigAction(context, param) {
    const res = await updateCorpConfigApi(param)
    return res
  },
  //  同步企业微信客服
  async synchCorpUserAction(context, param) {
    const res = await synchCorpUserApi(param)
    return res
  },
  //  获取企业微信客服列表
  async getCorpUserListAction(context, param) {
    const res = await getCorpUserListApi(param)
    return res
  },
  //  添加企业微信客服角色
  async addCorpUserRoleAction(context, param) {
    const res = await addCorpUserRoleApi(param)
    return res
  },
  //  获取企业微信客服角色
  async getCorpUserRoleListAction(context, param) {
    const res = await getCorpUserRoleListApi(param)
    return res
  },
  //  修改企业微信客服角色
  async updateCorpUserRoleAction(context, param) {
    const res = await updateCorpUserRoleApi(param)
    return res
  },
  //  删除企业微信客服角色
  async deleteCorpUserRoleAction(context, param) {
    const res = await deleteCorpUserRoleApi(param)
    return res
  },
  //  设置企业微信客服角色
  async setCorpUserRoleAction(context, param) {
    const res = await setCorpUserRoleApi(param)
    return res
  },
  //  激活企业微信客服
  async activateCorpUserAction(context, param) {
    const res = await activateCorpUserApi(param)
    return res
  },
  //  获取聊天记录列表
  async getChatRecordListAction(context, param) {
    const res = await getChatRecordListApi(param)
    return res
  },
  //  获取聊天记录详情列表
  async getChatRecordDetailListAction(context, param) {
    const res = await getChatRecordDetailListApi(param)
    return res
  },
  //  修改企业微信客服
  async updateCorpUserAction(context, param) {
    const res = await updateCorpUserApi(param)
    return res
  },
  //  获取微信小程序直播间列表
  async getWxAppLiveRoomListAction(context, param) {
    const res = await getWxAppLiveRoomListApi(param)
    return res
  },
  //  添加微信关联通知绑定
  async addWechatRelationNoticeBindAction(context, param) {
    const res = await addWechatRelationNoticeBindApi(param)
    return res
  },
  //  删除微信关联通知绑定
  async deleteWechatRelationNoticeBindAction(context, param) {
    const res = await deleteWechatRelationNoticeBindApi(param)
    return res
  },
  //  查询微信关联通知绑定信息
  async queryWechatRelationNoticeBindAction(context, param) {
    const res = await queryWechatRelationNoticeBindApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
